import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const Compliance = () => {

  return (
    <div className="termsservice_wrapper compliance_wrapper">
		<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/compliance-bgimg.jpg)`,}}>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="toptitlebox">
							<div className="breadcrumb_mainsec">
								<ul>
									<li><a href="#">Home</a></li>
									<li><span>Compliance</span></li>
								</ul>
							</div>
							
							<div className="titlesec">
								<h2>Compliance</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div className="termsservice_mainsec compliance_mainsec">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="contntbox">
							<h2>Compliance Statement for CoinViews</h2>
							
							<p>CoinViews is an informational service that curates cryptocurrency prices, news, staking opportunities, and airdrop announcements. We are not a regulated exchange or brokerage, and we do not execute trades, hold digital assets on your behalf, or provide personalized investment advice. All figures and incentives mentioned on CoinViews are shared for general knowledge, and it is your responsibility to ensure that any actions you take comply with your local laws.</p>
							
							<h2>Regulatory Compliance</h2>
							
							<p>The material on CoinViews should never be interpreted as a solicitation to buy or sell any digital asset, security, or financial product. We do not offer legal, tax, or investment advice. If you choose to transact with third‑party platforms, you may be required to complete know‑your‑customer (KYC) or anti‑money‑laundering (AML) checks. It is up to you to abide by the rules and regulations in your jurisdiction, and to seek professional guidance when needed.</p>
							
							<h2>Data Sources and Usage</h2>
							
							<p>Our price feeds and market data come from reputable third‑party providers. You agree not to scrape, redistribute, or otherwise misuse this data. We reserve the right to restrict access to data if required by our data providers or by applicable law.</p>
							
							<h2>Intellectual Property</h2>
							
							<p>Unless otherwise specified, all text, charts, and branding elements on CoinViews belong to us or our partners. You may not copy or reproduce this material without written permission.</p>
							
							<h2>Affiliate Relationships</h2>
							
							<p>CoinViews may include affiliate links to exchanges, wallets, or other services. When we receive compensation for referrals, we will clearly indicate this relationship. Affiliate partnerships do not influence our editorial decisions.</p>
							
							<h2>No Liability</h2>
							
							<p>CoinViews is offered “as is.” While we strive for accuracy, we do not guarantee that the information is complete, current, or error‑free. We are not liable for any losses or damages—including those arising from price volatility, cyberattacks, or changes in regulation—resulting from your use of the site. Where permitted by law, our liability to any user will not exceed the amount paid, if any, for accessing CoinViews.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default Compliance;